export const pageBasicsSelector = (state) => state.get('pages').get('basics');

export const pageOutgoingInternalLinksSelector = (state) => state.get('pages').get('outgoing_internal_links');

export const pageOutboundLinksSelector = (state) => state.get('pages').get('outbound_links');
